module.exports = __webpack_public_path__ + "static/img/partner4.ec1e7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner4.png
// module id = ao4z
// module chunks = 1